import React, {useContext} from "react";
import {Helmet} from "react-helmet-async";
import {
    Grid,
    Divider as MuiDivider,
    Typography,
    Button
} from "@mui/material";
import ListViewTable from "../../components/ListViewTable";
import {UsersContext} from "./store/users-context";

// Types
import {HeadCell} from "../../../types/headCell";

// Styling
import styled from "styled-components/macro";
import {spacing} from "@mui/system";
import {Add as AddIcon} from "@mui/icons-material";
import SearchBar from "../../components/SearchBar";

const Divider = styled(MuiDivider)(spacing);


function Users() {
    const usersCtx = useContext(UsersContext);

    // Set table headers data
    const headCells: Array<HeadCell> = usersCtx.headers;
    const model = 'User';

    //------------------------------- Public methods -------------------------------------


    return (
        <React.Fragment>
            <Helmet title="Users"/>
            <Grid item xs={12} mb={10}>
                <Typography variant="h1" gutterBottom display="inline">
                    Users
                </Typography>
            </Grid>
            <Grid justifyContent="space-between" container spacing={10} mb={10}>
                <Grid item>
                    <SearchBar text={usersCtx.search} onSearch={usersCtx.onSearch}/>
                </Grid>
                <Grid item>
                    <div>
                        <Button variant="contained" color="primary" onClick={usersCtx.addItem}  startIcon={<AddIcon/>}>
                            New User
                        </Button>
                    </div>
                </Grid>
            </Grid>

            <Grid item xs={12} className="shadow">
                <ListViewTable
                    key='list'
                    rows={usersCtx.items}
                    tableHeaders={headCells}
                    onDeleteHandler={usersCtx.removeItem}
                    onSelectHandler={usersCtx.selectItem}
                    onPaginateHandler={usersCtx.onPaginate}
                    onSortHandler={usersCtx.onSort}
                    count={usersCtx.count}
                    page={usersCtx.page}
                    rowsPerPage={usersCtx.rowsPerPage}
                    sorting={usersCtx.sorting}
                    filters={usersCtx.filters}
                    model={model}/>
            </Grid>
        </React.Fragment>
    );
}

export default Users;
